<template>
  <div id="video_dialog_outer">
    <video id="my_current_video" controls
           preload="auto"
           class="video-js vjs-default-skin"
           :width="videoWidth" height="auto" >
      <source :src="videoUrl" >
      您的浏览器不支持 HTML5 video 标签。
    </video>

    <a class="iconfont close-button"
       href="javascript:void(null);"
       @click="closeButtonClicked" >&#xe639;</a>
  </div>
</template>

<script>
export default {
  name: "VideoPlayDialog",
  props: [
    'videoUrl'
  ],
  data() {
    return {
      videoWidth: 960,
      videoPlayer: null,
    }
  },
  mounted() {
    $(window).resize(this.updateStatus);
    setTimeout(this.updateStatus, 100);

    let _this = this;
    let player = videojs('my_current_video', {}, function () {
      player.play();
      _this.videoPlayer = player;
    });

  },
  destroyed() {
    this.videoPlayer.pause();
    this.videoPlayer.dispose();
    this.videoPlayer = null;
  },
  methods: {
    updateStatus() {
      let screenWidth = document.body.clientWidth;
      let tmp = Math.round(screenWidth * 0.8) + '';
      _this.videoWidth = parseInt(tmp);
    },
    closeButtonClicked() {
      this.videoPlayer.pause();
      this.videoPlayer.dispose();
      this.videoPlayer = null;
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
  #video_dialog_outer {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.3);

    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: center;
  }

  #video_dialog_outer .close-button {
    position: absolute;
    top: 50px;
    right: 50px;
    color: white;
    font-size: 2rem;
    z-index: 999;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/VideoPlayDialog.vue